import { useEffect } from 'react';
import { hotjarService } from '../../../services/hotjar';

export const HotjarInitializer = () => {
  useEffect(() => {
    const hotjarId = import.meta.env.VITE_HOTJAR_ID;
    const hotjarSv = import.meta.env.VITE_HOTJAR_SV;
    const isProduction = import.meta.env.MODE === 'production';

    if (isProduction && hotjarId && hotjarSv) {
      hotjarService.initialize(hotjarId, hotjarSv);
    } else if (import.meta.env.DEV) {
      if (!isProduction) {
        console.log('[Hotjar] Skipped: Not in production mode');
      }
      if (!hotjarId || !hotjarSv) {
        console.warn('[Hotjar] Skipped: VITE_HOTJAR_ID or VITE_HOTJAR_SV not configured');
      }
    }
  }, []);

  return null;
};
